import { IGlobalConfig } from "../appRoutesConfig";
import { pageRoutes } from "../routes";
import React from "react";

const errorRoutesConfig: IGlobalConfig = [
  {
    auth: [],
    component: React.lazy(() => import("./error404")),
    title: "Psychology Reservation | Not Found",
    path: pageRoutes.ER404,
  },
  {
    auth: [],
    component: React.lazy(() => import("./error403")),
    title: "Psychology Reservation | No Access",
    path: pageRoutes.ER403,
  },
  {
    auth: [],
    component: React.lazy(() => import("./error500")),
    title: "Psychology Reservation | Internal Error",
    path: pageRoutes.ER500,
  },
];

export { errorRoutesConfig };
